<template>
  <v-container>
    <div class="head-title mb-4">
      <h1 class="display-1">{{ isModeProprio ? 'Coupons accordés' : 'Coupons utilisés' }}</h1>
    </div>
    <v-card class="rel">
      <!-- <v-tabs v-model="active" slider-color="secondary">
        <v-tab ripple>Coupons utilisés</v-tab>
        <v-tab ripple>Cadeaux</v-tab>
        <v-tab-item>
          <HeaderTable shadow @updateSearch="updateSearch">
            <v-data-table :headers="headersCoupon" :loading="loading" :items="getCoupons" :search="search" no-results-text="Votre recherche n'a retourné aucun resultat" footer-props.items-per-page-text="Éléments par page" no-data-text="Aucune donnée disponible.">
              <template slot="items" slot-scope="props">
                <td>{{ props.item }}</td>
                <td>{{ props.item }}</td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </HeaderTable>
        </v-tab-item>
        <v-tab-item>
          <HeaderTable shadow>
            <v-data-table @updateSearch="updateSearch" :headers="headersCadeaux" :items="cadeauxList" :search="search" no-results-text="Votre recherche n'a retourné aucun resultat" footer-props.items-per-page-text="Éléments par page" no-data-text="Aucune donnée disponible.">
              <template slot="items" slot-scope="props">
                <td>{{ props.item.montant }}</td>
                <td>{{ props.item.couponsUtilise }}</td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </HeaderTable>
        </v-tab-item>
      </v-tabs> -->
      <HeaderTable shadow @updateSearch="updateSearch">
        <v-data-table :headers="headersCoupon" :loading="loading" :items="couponsList" :search="search" no-results-text="Votre recherche n'a retourné aucun resultat" footer-props.items-per-page-text="Éléments par page" no-data-text="Aucune donnée disponible.">
          <template slot="items" slot-scope="props">
            <td>{{ props.item }}</td>
            <td>{{ props.item }}</td>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </HeaderTable>
      <div class="floating-btn abs d-flex justify-content-end" v-if="!isModeProprio">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" right dark fab top color="primary" @click="rewardCoupons = true">
              <v-icon>card_giftcard</v-icon>
            </v-btn>
          </template>
          <span>Récompenser par un coupon</span>
        </v-tooltip>
      </div>
    </v-card>
    <div v-if="!isModeProprio">
      <v-alert class="mt-4" :value="true" color="secondary" icon="card_giftcard" outlined>
        TOTAL DES COUPONS : <span class="font-weight-bold">{{ getCoupons ? getCoupons.length : 0 }}</span>
      </v-alert>
      <v-dialog v-model="rewardCoupons" max-width="400px">
        <v-card>
          <v-card-title class="title-dialog d-flex">
            <v-icon color="primary" class="mr-2">card_giftcard</v-icon>
            <span v-if="!isNewCouponValid"> Recompenser par un coupon</span>
            <span v-else> Voici le coupon à utiliser</span>
          </v-card-title>
          <v-divider />
          <v-card-text class="pt-3">
            <form v-if="!isNewCouponValid">
              <v-text-field
                label="Montant à transféfer"
                v-model="newCoupon.montant"
                type="number">
              </v-text-field>
              <v-text-field
                label="Courriel ou tel bénéficiaire"
                v-model="newCoupon.userName">
              </v-text-field>
            </form>
            <h3 class="title text-center my-4 secondary--text" v-else> {{ couponCode }} </h3>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions v-if="!isNewCouponValid">
            <v-btn text color="primary" class="d-block mx-auto" @click="createNewCoupon">transférer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
  import HeaderTable from '@/components/helpers/HeaderTable.vue'
  import { mapGetters } from 'vuex'
  import { GET_COUPONS_REQUEST, CREATE_COUPONS_REQUEST, GET_COUPONS_PROPRIO_REQUEST } from '@/store/actions/coupons'

  export default {
    name: 'Coupons',
    data: () => ({
      activeTab: null,
      active: 0,
      headersCoupon: [
          {
            text: 'Montant',
            align: 'left',
            sortable: true,
            value: 'montant'
          },
          {
            text: 'Coupon utilisé',
            align: 'left',
            sortable: true,
            value: 'couponsUtilise'
          },
      ],
      headersCadeaux: [
          {
            text: 'Montant',
            align: 'left',
            sortable: true,
            value: 'montant'
          },
          {
            text: 'Coupon utilisé',
            align: 'left',
            sortable: true,
            value: 'couponsUtilise'
          },
      ],
      search: '',
      rewardCoupons: false,
      newCoupon: {
        montant: null,
        userName: ''
      },
      isNewCouponValid: false,
      couponCode: '',
      loading: true
    }),
    computed: {
      ...mapGetters ([
        'getCoupons',
        'getCouponsProprio',
        'getProfile'
      ]),
      couponsList () {
        if (this.isModeProprio) {
          return this.getCouponsPoprio
        } else {
          return this.getCoupons
        }
      }
    },
    components: {
      HeaderTable
    },
    methods: {
      createNewCoupon () {
        let coupon = {
          uuid: this.getProfile.uuid,
          code: this.newCoupon.userName,
          montant: this.newCoupon.montant,
          // coupon_created_at: '',
          // depense_created_at: '',
          entrepreneur_nom: ''
        }
        this.$store.dispatch(CREATE_COUPONS_REQUEST, coupon).then(resp => {
          // console.log(resp)
          this.isNewCouponValid = true
          this.couponCode = resp.code
        })
      },
      updateSearch (search) {
        this.search = search
      }
    },
    watch: {
      rewardCoupons (val) {
        if (!val) {
          this.isNewCouponValid = false,
          this.couponCode = '',
          this.newCoupon.userName = '',
          this.newCoupon.montant = null
        }
      }
    },
    created () {
      if (this.isModeProprio) {
        this.$store.dispatch(GET_COUPONS_PROPRIO_REQUEST).finally(() => {
          this.loading = false
        })
      } else {
        this.$store.dispatch(GET_COUPONS_REQUEST).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.head-card {
  border-bottom: 1px solid #ddd;
}
</style>